import axios from 'axios/index';

export const GET_SUPERVISI = '[SUPERVISI] GET SUPERVISI';
export const GET_SUPERVISI_PENGAWAS_LAIN = '[SUPERVISI] GET SUPERVISI PENGAWAS LAIN';
export const GET_PENGAWAS = '[SUPERVISI] GET PENGAWAS';
export const SET_KONFIRMASI_SUPERVISI = '[SUPERVISI] SET KONFIRMASI SUPERVISI';

export function setKonfirmasiSupervisi(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/setKonfirmasiSupervisi', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : SET_KONFIRMASI_SUPERVISI,
                payload: response.data,
                routeParams
            })
        });
}

export function getSupervisi(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/Supervisi', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_SUPERVISI,
                payload: response.data,
                routeParams
            })
        });
}

export function getSupervisiPengawasLain(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/Supervisi', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_SUPERVISI_PENGAWAS_LAIN,
                payload: response.data,
                routeParams
            })
        });
}

export function getPengawas(routeParams)
{
    const baseUrl = localStorage.getItem('api_domain');
    const request = axios.post(baseUrl + '/api/getPengawas', {
        ...routeParams
    });

    return (dispatch) =>
        request.then((response) => {
            return dispatch({
                type   : GET_PENGAWAS,
                payload: response.data,
                routeParams
            })
        });
}


// WEBPACK FOOTER //
// ./src/store/actions/Supervisi.actions.js